// removed by extract-text-webpack-plugin
module.exports = {"base":"ButtonInbox_base--3fNZb","base__new-message":"ButtonInbox_base__new-message--1wRQ0","baseNewMessage":"ButtonInbox_base__new-message--1wRQ0","icon":"ButtonInbox_icon--25PDE","messages":"ButtonInbox_messages--mGHql"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-mt-bootstrap/lib/components/ButtonInbox/ButtonInbox.css
// module id = 1760
// module chunks = 16